import { captureMessage } from '@sentry/react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../utils/auth';
import { isExternalUrlAllowed, isUrlInternal } from '../utils/redirect';

class ForbiddenExternalDomainError extends Error {
  constructor() {
    super('DOMAIN_NOT_ALLOWED');
  }
}

export function useSafeLocationUpdate() {
  const navigate = useNavigate();
  return useCallback(
    (path: string, replace = false) => {
      try {
        const url = new URL(path);
        const isInternal = isUrlInternal(url);

        if (!isExternalUrlAllowed(url)) {
          throw new ForbiddenExternalDomainError();
        }

        captureMessage(`Safely redirecting user to: ${url.origin}`, 'debug');

        if (isInternal) {
          return navigate(url.pathname + url.search + url.hash, { replace });
        } else {
          return logout().then(() => {
            if (replace) {
              window.location.replace(url);
            } else {
              window.location.href = url.toString();
            }
          });
        }
      } catch (error) {
        if (error instanceof ForbiddenExternalDomainError) {
          throw error;
        }

        return navigate(path);
      }
    },
    [navigate],
  );
}
